module.exports = __webpack_public_path__ + "static/media/switch.b7497a5d.svg";